<rh-ui-button
  *ngIf="!isPanelOpen"
  class="help-button__trigger"
  labelInput="?"
  iconAriaLabelInput="Open the Resource Center"
  [noMinWidthInput]="true"
  (clickEventOutput)="openPanel()">
</rh-ui-button>
<rh-ui-card-dashboard
  *ngIf="isPanelOpen"
  class="resource-center" 
  titleInput="Resource Center"
  [colorInput]="visualColor.primary"
  [buttonActionsInput]="chevronButton"
  (actionOutput)="closePanel()">
  <div class="resource-center__items">
    <rh-ui-button
      *ngIf="hasPageGuide$ | async"
      class="resource-center__page-guide"
      labelInput="Explore page guide"
      iconInput="circle-info"
      [isIconRefInput]="true"
      [appearanceInput]="visualAppearance.text"
      (clickEventOutput)="openPageGuide()">
    </rh-ui-button>
    <rh-ui-button
      class="resource-center__training resource-center__item--training"
      labelInput="Visit the Training Library"
      iconInput="caret-right"
      [isIconRefInput]="true"
      [appearanceInput]="visualAppearance.text"
      (clickEventOutput)="openLink(trainingLibraryUrl)">
    </rh-ui-button>
    <rh-ui-button
      class="resource-center__feedback"
      labelInput="Leave feedback"
      iconInput="message"
      [isIconRefInput]="true"
      [appearanceInput]="visualAppearance.text">
    </rh-ui-button>
    <rh-ui-button
      class="resource-center__contact"
      labelInput="Contact ATPCO Support"
      iconInput="support-headset"
      [isIconRefInput]="true"
      [appearanceInput]="visualAppearance.text"
      (clickEventOutput)="openLink(serviceNowUrl)">
    </rh-ui-button>
  </div>
</rh-ui-card-dashboard>
